import React, {Component} from 'react';
import _ from 'lodash';

export default class GovermentServiceOptions extends Component {
  constructor(props){
    super(props)

    this.onChange = this.onChange.bind(this);
  }

  onChange(event){
    let value = event.target.value;
    this.props.handleChange(value);
  }

  render(){
    const { government_service } = this.props;

    return (
      <div className='row my-3'>
        <div className="col-12">
          <input 
            type='radio' 
            name='government_service' 
            value='ส่วนราชการ'
            className='mr-2'
            checked={government_service == "ส่วนราชการ"} 
            onChange={this.onChange}/> 
            ส่วนราชการ
        </div>
        <div className="col-12">
          <input 
            type='radio' 
            name='government_service' 
            value='ส่วนงานภายใน'
            className='mr-2'
            checked={government_service == "ส่วนงานภายใน"} 
            onChange={this.onChange}/> 
            ส่วนงานภายใน
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/documents/elements/GovermentServiceOptions.js